<template>
  <v-alert icon="fas fa-exclamation-triangle" color="yellow-darken-2" density="compact" class="mb-5">
    The file you've uploaded contains some headers that <b>might</b> be faulty:
    <v-list density="compact" bg-color="yellow-lighten-4" class="mt-2">
      <v-list-item
          density="compact"
          v-for="(header, index) in Array.from(differenceSet).slice(0, 5)"
          :key="index"
          size="sm"
          :title="header"
      />
      <v-expand-transition>
        <div v-show="isExpanded">
          <v-list density="compact" bg-color="yellow-lighten-4" class="pt-0">
            <v-list-item
                v-for="(header, index) in Array.from(differenceSet).slice(5)"
                :key="index"
                size="sm"
                :title="header"
            />
          </v-list>
        </div>
      </v-expand-transition>
      <v-btn
          v-if="differenceSet.size > 5"
          variant="text"
          color="primary"
          class="mt-2"
          @click="isExpanded = !isExpanded"
          :append-icon="isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
      >
        {{ isExpanded ? 'Show Less' : `Show More (${differenceSet.size - 5} more)` }}
      </v-btn>
    </v-list>
  </v-alert>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  differenceSet: { required: true }
});

const isExpanded = ref(false);
</script>